export default __webpack_public_path__ + "static/media/specialist@2x.980f503a.png";